<template>
  <div class="header-container">
    <el-menu class="gradient" default-active="1" mode="horizontal" @select="handleSelect" router>
      <img src="../../assets/white_logo.png" class="logo">
        <el-submenu index="" class="item-right profile-image" v-if="!isDirectSurvey">
          <template slot="title">
            <img src="../../assets/profile.png">
          </template>
          <el-menu-item v-if="!isAnonymousLogin  && !isForRecruitment" index="/home/user/resetPassword">Reset Password</el-menu-item>
          <el-menu-item index="/">Logout</el-menu-item>
        </el-submenu>
      <el-menu-item v-if="!isDirectSurvey && !isForRecruitment" class="item-right" index="/home">Home</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
  export default {
    name: 'appHeader',
    methods: {
      handleSelect(key) {
        if (key === '/') {
          this.$store.dispatch('logout');
        }
      },
    },
    computed: {
      isAnonymousLogin() {
        return localStorage.getItem('is_anonymous_login');
      },
      isDirectSurvey() {
        if (localStorage.getItem('directSurveyId')) {
          return localStorage.getItem('directSurveyId').length > 0;
        }
        return false;
      },
      isForRecruitment() {
        return window.location.hostname.split('.')[0] === 'recruitment';
      },
    },
  };
</script>

<style>
  .gradient {
    background-image: -webkit-linear-gradient( 0deg, rgb(76,136,179) 0%, rgb(22,66,98) 100%);
  }
  .logo {
    height: 50px;
    width: 125px;
    margin-left: 15px;
  }
  .header-container {
    position: fixed;
    width: 100%;
    z-index: 1000;
  }
  .el-menu .item-right{
    float: right;
  }
  .el-menu--horizontal.el-menu--dark .el-menu-item:hover,
  .el-menu--horizontal.el-menu--dark .el-submenu__title:hover {
    background-color: #21559e;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #409EFF;
    color: #fdfdfd;
  }
  .el-dropdown-menu__item--divided:before, .el-menu, .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background-color: #ffffff00;
  }
  .is-opened{
    color: #21559e;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    color: #409eff;
  }
  .el-menu--horizontal>.el-menu-item {
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?cb5e6f76